import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IIntercomState } from './intercom-state';
import { BootIntercomAction, ShutdownIntercomAction } from './intercom-actions';
import { INTERCOM_BOOT, INTERCOM_SHUTDOWN } from '../action-types';
import { getCompany, getUser } from '../session/session-selectors';
import { tap, withLatestFrom } from 'rxjs';
import { Company } from '@core/models/common/company';
import { User } from '@core/models/user/user';
import { IntercomService } from '@vendor/intercom/intercom.service';

@Injectable()
export class IntercomEffects {

    constructor(private store$: Store<IIntercomState>,
                private actions$: Actions,
                private intercomService: IntercomService) {
    }

    /**
     * Boot intercom widget
     */
    bootIntercom$ = createEffect(() => this.actions$.pipe(
        ofType<BootIntercomAction>(INTERCOM_BOOT),
        withLatestFrom(
            this.store$.select(getUser),
            this.store$.select(getCompany)
        ),
        tap(([_, user, company]: [BootIntercomAction, User, Company]) => {
            this.intercomService.boot(user, company);
        })
    ), { dispatch: false });

    /**
     * Shut down intercom widget
     */
    shutDownIntercom$ = createEffect(() => this.actions$.pipe(
        ofType<ShutdownIntercomAction>(INTERCOM_SHUTDOWN),
        tap((_) => {
            this.intercomService.shutDown();
        })
    ), { dispatch: false })
}
